import 'jquery-validation'
import "jquery-validation/dist/additional-methods.js"
import Cookies from 'js-cookie';
import {recordEvent} from 'js/ts/tracking'

interface SupplierRfqResponse {
  message: string
  success: boolean
  supplierIdsAlreadyRecorded: number[]
  supplierIds: number[]
  error: boolean
  errorMessage: string
}

export default class ProductRfqForm {

  constructor() {
    $("#sitewide-overlay, #rfq-dialog .close, #rfq-dialog .cancel, #rfq-dialog .done")
      .on("click", () => $("#rfq-dialog, #sitewide-overlay").fadeOut())

    this.attachFormValidation()
    this.attachEventTracking()
    this.autoAdjustMessageBoxHeight()
  }

  private autoAdjustMessageBoxHeight() {
    const rfqMessage = document.getElementById("rfq-message");
    if (rfqMessage) {
      rfqMessage.setAttribute("style", `height:${rfqMessage.scrollHeight}px;`);
      rfqMessage.addEventListener("input", () => {
        rfqMessage.style.height = "auto";
        rfqMessage.style.height = `${rfqMessage.scrollHeight}px`;
      }, false);
    }
  }

  private attachFormValidation() {
    $("#rfq-form").validate({
      ignore: ':hidden:not(.do-not-ignore)',
      rules: {
        products: {
          required: true,
        },
        quantity: {
          required: true,
        },
        "needed-by": {
          required: true,
          date: true,
        },
        email: {
          required: true,
        },
        company: {
          required: true,
        },
        message: {
          required: true,
        },
        hiddenRecaptcha: {
          required: true,
          pattern: /^true$/,
        },
      },
      errorClass: "validation-error",
      errorElement: "span",
      messages: {
        products: {
          required: "Select one or more suppliers",
        },
        quantity: {
          required: "Enter a quantity",
        },
        "needed-by": {
          required: "Enter a needed by date",
        },
        email: {
          required: "Enter your email address",
        },
        company: {
          required: "Enter a company name",
        },
        message: {
          required: "Enter a brief message",
        },
        hiddenRecaptcha: ''
      },
      errorPlacement: (error, element) => {
        if (element.attr("name") == "suppliers") {
          error.appendTo($('#rfq-dialog .multi-select'));
        } else {
          error.insertAfter(element);
        }
      },
      invalidHandler: (form, validator) => {
        if (!validator.numberOfInvalids())
          return;

        $('html, body').animate({
          scrollTop: ($(validator.errorList[0].element).offset().top - 50)
        }, 500);
      },
      submitHandler: () => {
        ProductRfqForm.showLoading()
        this.submitRfqForm()
      }
    });
  }

  private submitRfqForm() {
    $.ajax({
      url: "/ajax/product/rfq",
      type: "POST",
      data: $("#rfq-form").serialize(),
      timeout: 20000,
      dataType: "json",
    }).then((result: SupplierRfqResponse) => {
      if (result.error === true) {
        ProductRfqForm.showError(result.message)
      } else {
        this.showSuccess(result.message)
      }
      $("#rfq-dialog").removeClass("submitting")

      // We want to filter out any supplierIds that have already had a web lead recorded
      const filteredSupplierIds = result.supplierIds.filter((id) => !result.supplierIdsAlreadyRecorded.includes(id))
      if (filteredSupplierIds.length) {
        recordEvent("event19", {eVar27: 'Product1', list3: filteredSupplierIds.join()})
      }
      // record the RFQ lead for all suppliers selected in form
      recordEvent('event68,event19', {eVar27: 'RFQ', list3: result.supplierIds.join()}, 'RFQ Submitted');

      // This field is used to determine when web leads have already been recorded.
      // Update this field in both forms with the ID's we just finished recording for.
      $("input[name='supplierIdsAlreadyRecorded']").val(result.supplierIds.join())
    }).catch(() => {
      ProductRfqForm.showError("An Error occurred. Your RFQ was not sent. Please try again later.")
      $("#rfq-dialog").removeClass("submitting")
    });
  }

  private static showError(message: string) {
    $("#rfq-dialog .error .message").html(message);
    $("#rfq-dialog #rfq-form").fadeIn(300)
    $("#rfq-dialog .error").fadeIn(300)[0].scrollIntoView({behavior: "smooth", block: "center"});
    $(".loading").hide()
  }

  private showSuccess(message: string) {
    $("#rfq-dialog .success .message").html(message);
    setTimeout(() => {
      $("#rfq-dialog .loading").fadeOut(300, () => {
        $("#rfq-dialog .success").css("display", "flex")
          .hide()
          .fadeIn(300)[0].scrollIntoView({behavior: "smooth", block: "center"})
      })
    }, 650)
  }

  private static showLoading() {
    $("#rfq-form").hide()
    $("#rfq-dialog .loading").fadeIn(300)[0].scrollIntoView({behavior: "smooth", block: "center"})
  }

  private static recordRfqFormEvent(event: string, description: string) {
    recordEvent(event, {eVar3: s.eVar3, eVar4: s.eVar4, prop3: s.eVar4, eVar13: s.eVar13}, description)
  }

  private attachEventTracking() {
    $("#rfq-form input[name='quantity']").on('focusout', () => {
      ProductRfqForm.recordRfqFormEvent('event122', 'RFQ form input: Quantity')
    });

    $("#rfq-form input[name='units']").on('focusout', () => {
      ProductRfqForm.recordRfqFormEvent('event123', 'RFQ form input: Unit')
    });

    $("#rfq-form input[name='needed-by']").on('focusout', () => {
      ProductRfqForm.recordRfqFormEvent('event124', 'RFQ form input: Needed By');
    });

    $("#rfq-form input[name='budget']").on('click', (event) => {
      if ((event.target as HTMLInputElement).checked) {
        ProductRfqForm.recordRfqFormEvent('event125', 'RFQ form input: Budget Allocated Selected');
      } else {
        ProductRfqForm.recordRfqFormEvent('event125', 'RFQ form input: Budget Allocated Deselected');
      }
    });

    $("#rfq-form input[name='company']").on('focusout', () => {
      ProductRfqForm.recordRfqFormEvent('event127', 'RFQ form input: Company');
    });

    $("#rfq-form input[name='phone']").on('focusout', () => {
      ProductRfqForm.recordRfqFormEvent('event128', 'RFQ form input: Phone');
    });

    $("#rfq-form textarea[name='message']").on('focusout', () => {
      ProductRfqForm.recordRfqFormEvent('event129', 'RFQ form input: Message');
    });
  }
}

const resetRfqForm = () => {
  $("#rfq-dialog .loading, #rfq-dialog .success, #rfq-dialog .error").hide()
  $("#rfq-dialog #rfq-form").show()
}

export const showRfqForm = () => {
  resetRfqForm()

  const currentElement = $("#supplier-table-row-1 gs-button.supplier-site-link")
  const supplierRow = currentElement.closest(".supplier")

  const type = currentElement.data('type')
  const status = supplierRow.data('status')
  const supplierId = supplierRow.data('id')
  const productNumber = supplierRow.data('product-number')
  const isCanonical = supplierRow.data('is-canonical')
  const supplierType = supplierRow.data('type')

  const trackingVariables = {
    eVar27: type,
    eVar47: status,
    eVar4: supplierId,
    prop3: supplierId,
    eVar82: isCanonical,
    eVar83: supplierType,
    eVar95: productNumber
  }

  recordEvent('event67', trackingVariables, 'Request a Quote');

  if (Cookies.get("GSUSER") !== undefined) {
    instantiateReCaptcha("#rfq-form .captcha-wrapper");
    $('#rfq-dialog, #sitewide-overlay').fadeIn();
    $("html").animate({scrollTop: 0}, "slow");
  }
}